module.exports = __webpack_public_path__ + "img/ic_content.0f029793.png";